import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getNotifications,
  markAllNotificationsAsRead,
  markNotificationAsRead,
  clearNotifications,
  deleteNotification,
} from "../../api/settings/notification";
import { toast } from "react-toastify";

export const useNotification = (enabled = true) => {
  return useQuery({
    queryKey: ["notifications"],
    queryFn: getNotifications,
    enabled,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export const useMarkAllNotificationsRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: markAllNotificationsAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
      toast.success("All alerts marked as read");
    },
    onError: () => {
      toast.error("Failed to mark all alerts as read");
    },
  });
};

export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => markNotificationAsRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
    onError: () => {
      toast.error("Failed to mark alert as read");
    },
  });
};

export const useClearNotifications = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: clearNotifications,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
      toast.success("All alerts cleared");
    },
    onError: () => {
      toast.error("Failed to clear alerts");
    },
  });
};

export const useDeleteNotification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteNotification(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
      toast.success("Alert deleted successfully");
    },
    onError: () => {
      toast.error("Failed to delete alert");
    },
  });
};
